import { cn } from "~/lib/utils";

// // // //

export type ChartWatermark =
    "none" | "bottom-right" | "center-30pct" | "center-40pct" | "center-50pct";

/**
 * getChartWatermarkClassName
 * Maps a ChartWatermark value to the css class that renders the RWA.xyz
 * lockup over a chart. See "Chart Watermark CSS" in src/styles/tailwind.css.
 *
 * @param {ChartWatermark} props.watermark - The watermark placement.
 */
export function getChartWatermarkClassName(props: {
    watermark: ChartWatermark;
}): string {
    const { watermark } = props;

    return cn({
        "chart-watermark-bottom-right": watermark === "bottom-right",
        "chart-watermark-center-30pct": watermark === "center-30pct",
        "chart-watermark-center-40pct": watermark === "center-40pct",
        "chart-watermark-center-50pct": watermark === "center-50pct",
    });
}
